import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetOneSC_NT_RI_ResearcherIndicators = createAsyncThunk(
  "SC_NT_RI_ResearcherIndicators/GetOneSC_NT_RI_ResearcherIndicators",
  async (parameters, { rejectWithValue }) => {
    try {
        await initializeApiClient("application/json");
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SC_NT_RI_ResearcherIndicators/GetOneSC_NT_RI_ResearcherIndicators",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateSC_NT_RI_ResearcherIndicators = createAsyncThunk(
  "SC_NT_RI_ResearcherIndicators/UpdateSC_NT_RI_ResearcherIndicators",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SC_NT_RI_ResearcherIndicators/UpdateSC_NT_RI_ResearcherIndicators",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ResearcherIndicators = createSlice({
  name: "ResearcherIndicators",
  initialState: {
    //------------- GetResearcherIndicators ---------------------
    ResearcherIndicators: {},
    loadingResearcherIndicators: false,
    errorResearcherIndicators: null,
    //------------- UpdateResearcherIndicators ---------------------
    UpdateResearcherIndicators: {},
    loadingUpdateResearcherIndicators: false,
    errorUpdateResearcherIndicators: null,
  },
  reducers: {
    setResearcherIndicators: (state, action) => {
      state.ResearcherIndicators = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetOneSC_NT_RI_ResearcherIndicators.pending, (state, action) => {
        console.log(action.payload, "action.payload");

        state.loadingResearcherIndicators = true;
        state.ResearcherIndicators = action.payload;
        state.errorResearcherIndicators = null;
      })
      .addCase(
        GetOneSC_NT_RI_ResearcherIndicators.fulfilled,
        (state, action) => {
          state.loadingResearcherIndicators = false;
          state.ResearcherIndicators = action.payload;
        }
      )
      .addCase(
        GetOneSC_NT_RI_ResearcherIndicators.rejected,
        (state, action) => {
          state.loadingResearcherIndicators = false;
          state.ResearcherIndicators = action.payload;
        }
      );
    //------------------- UpdateResearcherIndicators -----------------------------------
    builder
      .addCase(UpdateSC_NT_RI_ResearcherIndicators.pending, (state, action) => {
        state.loadingUpdateResearcherIndicators = true;
        state.UpdateResearcherIndicators = action.payload;
        state.errorUpdateResearcherIndicators = null;
      })
      .addCase(
        UpdateSC_NT_RI_ResearcherIndicators.fulfilled,
        (state, action) => {
          state.loadingUpdateResearcherIndicators = false;
          state.UpdateResearcherIndicators = action.payload;
        }
      )
      .addCase(
        UpdateSC_NT_RI_ResearcherIndicators.rejected,
        (state, action) => {
          state.loadingUpdateResearcherIndicators = false;
          state.errorUpdateResearcherIndicators = action.payload;
        }
      );
  },
});
export const { setResearcherIndicators } = ResearcherIndicators.actions;
export default ResearcherIndicators.reducer;
